import { useLocation, useParams } from "react-router";
import { useCollection, useCollectionFetching, useSpace } from "@/api/hooks";
import { useGetRecordQuery } from "@/api/api";

import { PropsWithChildren, ReactNode } from "react";
import CurrentIntervalWidget from "./CurrentIntervalWidget";
import CurrentPageWidget from "./CurrentPageWidget";

export function HeaderText({ children }: PropsWithChildren) {
  return (
    <span
      className="text-[16px] font-semibold text-foreground"
      style={{ fontFamily: "var(--font-serif)" }}
    >
      {children}
    </span>
  );
}

export default function Header() {
  // const globalStacks = useGlobalStacks();
  const location = useLocation();
  const { collectionID, recordID } = useParams();
  const collection = useCollection();
  const collectionIsFetching = useCollectionFetching();
  const { isOwn, owner } = useSpace();
  const {
    isFetching: recordIsFetching,
    isError: recordIsError,
    data: record,
  } = useGetRecordQuery(recordID || "", {
    skip: recordID === null || recordID === undefined,
  });

  let leftElement: ReactNode = null;
  let rightElement: ReactNode = <CurrentIntervalWidget />;

  if (collectionID) {
    if (collectionIsFetching) {
      leftElement = <HeaderText>Loading...</HeaderText>;
    } else if (!collection) {
      leftElement = <HeaderText>Collection is not accessible</HeaderText>;
    } else {
      leftElement = (
        <CurrentPageWidget>
          {collection.title}
        </CurrentPageWidget>
      );
    }
  } else if (location.pathname === "/admin") {
    rightElement = null;
    leftElement = <HeaderText>Users</HeaderText>;
  } else if (location.pathname === "/login") {
    rightElement = null;
    leftElement = <HeaderText>Sign in</HeaderText>;
  } else if (location.pathname.startsWith("/record")) {
    rightElement = null;
    if (recordID) {
      if (location.pathname.endsWith("/edit")) {
        leftElement = <HeaderText>Edit record</HeaderText>;
      } else if (recordIsFetching) {
        leftElement = <HeaderText>Loading...</HeaderText>;
      } else if (recordIsError || !record) {
        leftElement = <HeaderText>Record is not accessible</HeaderText>;
      } else {
        leftElement = <HeaderText>Record</HeaderText>;
      }
    } else {
      leftElement = <HeaderText>New record</HeaderText>;
    }
  } else {
    // `/` is not "everything" — the API scopes it to the signed-in user, and
    // `/:userID` scopes it to that person.
    leftElement = (
      <CurrentPageWidget>
        {isOwn
          ? "Your collections"
          : owner?.name
            ? `${owner.name}'s collections`
            : // Someone else's space, but we have no name to put on it —
              // "Your collections" here would claim it as the reader's own.
              "Collections"}
      </CurrentPageWidget>
    );
  }
  return (
    <header className="bg-card sticky top-0 z-50 border-b min-h-[55px]">
      <div className="h-full flex items-center justify-between py-2 px-4">
        <div className="flex items-center">{rightElement}</div>
        <div className="flex items-center">{leftElement}</div>
      </div>
    </header>
  );
}
